// @flow
import React, { Fragment } from 'react';
import { FileText } from '@finect/tabular-icons/fileText';
import { Link } from 'react-router-dom';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Image } from '@finect/tabular-components/Image';
import { STOREFRONT_REDIRECTS } from '@finect/tabular-components/HTML';
import { getArticlePath } from '../../../../utils/articles';
import {
  ArticleSidebarBlock,
  ArticleSidebarTitle,
  RelatedContent,
  ArticleSidebarSquareImage,
  ArticleSidebarSquareIcon
} from '../../../../components';

const optimizeImage = (image, height) => {
  if (!image.includes('finect.com')) return image;
  const url = image.replace('.com/image/', '.com/v4/resources/media/images/');

  const split = url.split('-');
  const id = split[0];
  // sizeParam starts with an w or h and is followed by a number
  const formatParam = split.find(s => s.match(/^[a-z]{3,4}$/));

  return `${id}${height ? `-h${height}` : ''}${formatParam ? `-${formatParam}` : ''}`;
};

type Props = {
  article: Object,
  author: Object,
  storefronts: Array<Object>,
  articlesFeed: Object,
  relatedGroupArticles: Object
};

export class ArticleSidebar extends React.Component<Props> {
  render() {
    const { article, storefronts, author, articlesFeed, relatedGroupArticles } = this.props;

    if (articlesFeed.fetching || relatedGroupArticles.fetching) return null;

    const isGroupSidebar = author.subtype === 'company' && relatedGroupArticles.items.length > 0;
    const relatedArticles = isGroupSidebar ? relatedGroupArticles : articlesFeed;

    const { id } = article || {};

    const maxDesktop = typeof window !== 'undefined' ? window.innerWidth < 1024 : false;
    return (
      <ArticleSidebarBlock>
        <div>
          <ArticleSidebarTitle
            href={isGroupSidebar ? `/grupos/${author.alias}` : `/articulos-financieros/noticias`}
            as="a"
            data-fi-event="blogs-aside"
          >
            {isGroupSidebar ? (
              <>
                Más artículos de <u>{author.displayName}</u>
              </>
            ) : (
              <>Más en Finect</>
            )}
          </ArticleSidebarTitle>

          {relatedArticles.items
            .filter(item => item.id !== id)
            .slice(0, maxDesktop ? 2 : 4)
            .map((item) => {
              const path = getArticlePath(item);
              const image = item.image && optimizeImage(item.image, 48);

              return (
                <RelatedContent key={`item-${item.id}`}>
                  {image ? (
                    <ArticleSidebarSquareImage as="a" href={path} alt={item.title} data-fi-event="article-aside">
                      <Image alt={item.title} src={image} width={48} height={48} />
                    </ArticleSidebarSquareImage>
                  ) : (
                    <ArticleSidebarSquareIcon as="a" href={path} alt={item.title} data-fi-event="article-aside">
                      <FileText size="36" strokeWidth="1" />
                    </ArticleSidebarSquareIcon>
                  )}

                  <div>
                    <h4>
                      <a href={path} alt={item.title} data-fi-event="article-aside">
                        {item.title}
                      </a>
                    </h4>
                  </div>
                </RelatedContent>
              );
            })}

          <br />
          <AppLink
            as={Link}
            to={isGroupSidebar ? `/grupos/${author.alias}` : `/articulos-financieros/noticias`}
            data-fi-event="blogs2-aside"
          >
            Ver todos los contenidos
          </AppLink>
          <br />
          <br />
        </div>

        {storefronts.length ? (
          <div>
            <ArticleSidebarTitle to="/" as={Link}>
              Invertir en
            </ArticleSidebarTitle>

            {storefronts.map((item) => {
              const hasMainCategory = (item.categories || []).find(category => category.type === 'main');
              const hasRedirect = STOREFRONT_REDIRECTS.find(redirect => redirect.tag === item.alias);
              const path = hasMainCategory
                ? `/fondos-inversion/categorias/${hasMainCategory.id}-${hasMainCategory.alias}`
                : hasRedirect
                  ? hasRedirect.to
                  : `/invertir/${item.alias}`;

              const linkProps = !hasMainCategory && hasRedirect ? { href: path } : { to: path, as: Link };

              return (
                <RelatedContent key={item.id}>
                  <div>
                    <h4>
                      <AppLink title={item.name} data-fi-event="article-aside" {...linkProps}>
                        {item.name}
                      </AppLink>
                    </h4>
                  </div>
                </RelatedContent>
              );
            })}
          </div>
        ) : null}
      </ArticleSidebarBlock>
    );
  }
}
